<template>
  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_11699_6092)">
      <path
          d="M2.32955 15.0437H1.19586L1.9975 14.242C2.42973 13.8098 2.69964 13.2476 2.77221 12.6378C0.92122 11.4231 0 9.66333 0 7.81851C0 4.41503 3.12812 0.956299 8.02711 0.956299C13.2171 0.956299 16 4.13898 16 7.52033C16 10.924 13.1877 14.1045 8.02711 14.1045C7.12311 14.1045 6.17979 13.9838 5.33758 13.7624C4.54033 14.5801 3.46011 15.0437 2.32955 15.0437V15.0437Z"
          fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="clip0_11699_6092">
        <rect width="16" height="16" fill="white"/>
      </clipPath>
    </defs>
  </svg>

</template>

<script>
export default {
  name: "IconSpeechBubble"
}
</script>

<style scoped>

</style>